// Evolution Scroll Functionality
document.addEventListener('DOMContentLoaded', function() {
  // Seleccionar todos los botones con la clase handle-action
  const handleActionButtons = document.querySelectorAll('.evolution-banner__a.handle-action');
  
  // Verificar si estamos en una página que contiene la sección objetivo
  const hasSelectProductsSection = document.querySelector('.select-products__type-top') || 
                                  document.querySelector('.select-products__title--one');
  
  // Función para crear el indicador de scroll
  function createScrollIndicator() {
    const indicator = document.createElement('div');
    indicator.className = 'scroll-indicator';
    document.body.appendChild(indicator);
    return indicator;
  }
  
  // Función para hacer scroll suave hacia la sección objetivo
  function scrollToSelectProducts() {
    // Crear y activar el indicador de scroll
    const scrollIndicator = createScrollIndicator();
    scrollIndicator.classList.add('active');
    
    // Remover el indicador después de la animación
    setTimeout(() => {
      scrollIndicator.classList.remove('active');
      setTimeout(() => {
        if (scrollIndicator.parentNode) {
          scrollIndicator.parentNode.removeChild(scrollIndicator);
        }
      }, 300);
    }, 1000);
    // Buscar la sección objetivo
    const targetSection = document.querySelector('.select-products__type-top.select-products__type-top--two-cols');
    const targetTitle = document.querySelector('.select-products__title.select-products__title--one');
    
    if (targetSection) {
      // Calcular la posición de la sección
      const sectionPosition = targetSection.offsetTop;
      
      // Hacer scroll suave hacia la sección
      window.scrollTo({
        top: sectionPosition - 100, // 100px de offset para mejor visualización
        behavior: 'smooth'
      });
      
      // Agregar efecto visual para destacar la sección
      setTimeout(() => {
        targetSection.classList.add('scroll-highlight');
        
        setTimeout(() => {
          targetSection.classList.remove('scroll-highlight');
        }, 1000);
      }, 500);
      
    } else if (targetTitle) {
      // Si no encuentra la sección específica, buscar el título
      const titlePosition = targetTitle.offsetTop;
      
      window.scrollTo({
        top: titlePosition - 100,
        behavior: 'smooth'
      });
      
      // Efecto visual para el título
      setTimeout(() => {
        targetTitle.classList.add('scroll-highlight');
        
        setTimeout(() => {
          targetTitle.classList.remove('scroll-highlight');
        }, 1000);
      }, 500);
      
    } else {
      // Si no encuentra ningún elemento, mostrar mensaje en consola
      console.log('No se encontró la sección objetivo para el scroll');
    }
  }
  
  // Agregar event listeners a todos los botones
  handleActionButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault(); // Prevenir el comportamiento por defecto del enlace
      
      // Solo hacer scroll si la sección objetivo existe en la página
      if (hasSelectProductsSection) {
        scrollToSelectProducts();
      } else {
        // Si no existe la sección en esta página, redirigir a la página principal
        window.location.href = '/#select-products';
      }
    });
  });
  
  // También agregar funcionalidad para botones con solo la clase handle-action
  const allHandleActionButtons = document.querySelectorAll('.handle-action');
  
  allHandleActionButtons.forEach(button => {
    // Solo agregar el listener si no es un botón evolution-banner__a (para evitar duplicados)
    if (!button.classList.contains('evolution-banner__a')) {
      button.addEventListener('click', function(e) {
        // Verificar si el botón tiene un href válido
        const href = this.getAttribute('href');
        if (href && href !== '#' && href !== '') {
          // Si tiene un href válido, no prevenir el comportamiento por defecto
          return;
        }
        
        e.preventDefault();
        scrollToSelectProducts();
      });
    }
  });
  
  // Función adicional para scroll con hash en la URL
  function handleHashScroll() {
    if (window.location.hash === '#select-products') {
      setTimeout(() => {
        scrollToSelectProducts();
      }, 100);
    }
  }
  
  // Ejecutar al cargar la página
  handleHashScroll();
  
  // Escuchar cambios en el hash
  window.addEventListener('hashchange', handleHashScroll);
});

// Función global para usar desde otros scripts
window.scrollToSelectProducts = function() {
  const targetSection = document.querySelector('.select-products__type-top.select-products__type-top--two-cols');
  const targetTitle = document.querySelector('.select-products__title.select-products__title--one');
  
  if (targetSection) {
    const sectionPosition = targetSection.offsetTop;
    window.scrollTo({
      top: sectionPosition - 100,
      behavior: 'smooth'
    });
  } else if (targetTitle) {
    const titlePosition = targetTitle.offsetTop;
    window.scrollTo({
      top: titlePosition - 100,
      behavior: 'smooth'
    });
  }
}; 